import React from "react";
import propTypes from "prop-types";
import { Card, Col, Row } from "react-bootstrap";
import { filterField } from "components/ClinksOrgDetails/SearchInfoFieldsComponents/constants";
const SearchCriteriaComponents = ({ clicksData }) => {
  const CheckSearchCriteria = filterField.filter(
    (box, idx) => clicksData?.[box.name]?.length,
  );
  return (
    <>
      {CheckSearchCriteria && CheckSearchCriteria.length > 0 ? (
        <div className="orgd__conitems conitems__criteria">
          <h4 className="conitems__title text-dark fw-bold">Areas covered</h4>
          <Row className="g-3">
            {filterField.map((box, idx) =>
              clicksData?.[box.name]?.length ? (
                <Col md={3} sm={6} xs={12} key={idx}>
                  <div className="criteria__box border-0 rounded">
                    <h6 className="fw-bold text-dark">{box.title}</h6>
                    <ul
                      className="criteria__list mt-3 mb-0 ps-1"
                      style={{ maxHeight: "160px", overflow: "hidden auto" }}
                    >
                      {clicksData?.[box.name].map((item, i) => (
                        <li className="text-gray position-relative" key={i}>
                          {item.label}
                        </li>
                      ))}
                    </ul>
                  </div>
                </Col>
              ) : (
                ""
              ),
            )}
          </Row>
        </div>
      ) : (
        ""
      )}
    </>
  );
};
SearchCriteriaComponents.propTypes = {
  history: propTypes.object,
};
export default SearchCriteriaComponents;
